import { equal, ternary } from './javascript'
import { stringValue } from './regex'

export const nullValue = (value) =>
  ternary(!value || value.trim() === '', true, false)

const nameValidation = (value, msg) => {
  if (nullValue(value)) {
    return `${msg} is required`
  }
  if (!stringValue(value)) {
    return `Please enter valid ${msg}`
  }
  return false
}
const dateValidation = (value, msg) => {
  if (nullValue(value)) {
    return `${msg} is required`
  }
  return false
}
// const numberValidation = (value, msg) => {
//   if (nullValue(value)) {
//     return `${msg} is required`
//   }
//   if (stringValue(value)) {
//     return `Please enter valid ${msg}`
//   }
//   return false
// }
const CreditCardValidation = (value, msg) => {
  if (nullValue(value)) {
    return `${msg} is required`
  }
  if (stringValue(value)) {
    return `Please enter valid ${msg}`
  }
  if (value.length !== 4) {
    return 'Credit card number should be 4 digit'
  }
  return false
}

const nullValidation = (value, msg) => {
  if (nullValue(value)) {
    return `${msg} is required`
  }
  return false
}

const submissionValidation = (name, value, formType) => {
  if (equal(formType, 'PURCHASE_ORDER')) {
    switch (name) {
      case 'description':
        return nullValidation(value, 'Description')
      default: {
        return ''
      }
    }
  }
  if (equal(formType, 'WIRE_TRANSFER')) {
    switch (name) {
      case 'dateRequired':
        return dateValidation(value, 'Date Required')
      case 'invoiceNumber':
        return dateValidation(value, 'Invoice Number')
      case 'bankName':
        return nameValidation(value, 'Bank Name')
      case 'accountName':
        return nameValidation(value, 'Account Name')
      case 'bankAddress':
        return dateValidation(value, 'Bank Address')
      case 'routingNumber':
        return dateValidation(value, 'Routing Number')
      case 'accountNumber':
        return dateValidation(value, 'Account Number')
      case 'currency':
        return dateValidation(value, 'Currency')
      default: {
        return ''
      }
    }
  }
  if (equal(formType, 'CHECK_REQUEST')) {
    switch (name) {
      case 'dateRequired':
        return dateValidation(value, 'Date Required')
      case 'invoiceNumber':
        return dateValidation(value, 'Invoice Number')
      default: {
        return ''
      }
    }
  }
  if (equal(formType, 'CREDIT_CARD_CHARGE')) {
    switch (name) {
      case 'creditCardNumber':
        return CreditCardValidation(value, 'Credit Card Number')
      case 'creditCardAccountName':
        return nameValidation(value, 'Credit Card Account Name')
      default: {
        return ''
      }
    }
  }
  return ''
}

export default submissionValidation
